// Přílohy: nahrání na backend a druh souboru pro ikonu (barvy podle dema).
import { CSRF_HEADER, type AttachmentDTO } from '@sam/shared';
import { ApiError } from './api';

export async function uploadFile(file: File, signal?: AbortSignal): Promise<AttachmentDTO> {
  const fd = new FormData();
  fd.append('file', file, file.name);
  const res = await fetch('/api/files', { method: 'POST', body: fd, credentials: 'same-origin', headers: { [CSRF_HEADER]: '1' }, signal });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, j.error ?? `Nahrání selhalo (${res.status}).`);
  return j.file as AttachmentDTO;
}

const KIND: Record<string, [string, string]> = {
  pdf: ['PDF', '#E5484D'],
  doc: ['DOC', '#3E7BFA'],
  docx: ['DOC', '#3E7BFA'],
  rtf: ['DOC', '#3E7BFA'],
  odt: ['DOC', '#3E7BFA'],
  xls: ['XLS', '#2FA463'],
  xlsx: ['XLS', '#2FA463'],
  ods: ['XLS', '#2FA463'],
  csv: ['CSV', '#2FA463'],
  ppt: ['PPT', '#F5762E'],
  pptx: ['PPT', '#F5762E'],
  key: ['KEY', '#F5762E'],
  zip: ['ZIP', '#9A9AA6'],
  rar: ['RAR', '#9A9AA6'],
  '7z': ['7Z', '#9A9AA6'],
  txt: ['TXT', '#9A9AA6'],
  md: ['MD', '#9A9AA6'],
  log: ['LOG', '#9A9AA6'],
  json: ['JSON', '#C9A227'],
  xml: ['XML', '#C9A227'],
  html: ['HTML', '#C9A227'],
  js: ['JS', '#C9A227'],
  ts: ['TS', '#C9A227'],
  sql: ['SQL', '#C9A227'],
  mp3: ['MP3', '#B06CF0'],
  wav: ['WAV', '#B06CF0'],
  m4a: ['M4A', '#B06CF0'],
  mp4: ['MP4', '#B06CF0'],
  mov: ['MOV', '#B06CF0'],
  svg: ['SVG', '#F5762E'],
};

export function fileKind(name: string, mime: string): { label: string; color: string; image: boolean } {
  const ext = name.includes('.') ? name.split('.').pop()!.toLowerCase() : '';
  const k = KIND[ext];
  return {
    label: k ? k[0] : ext ? ext.toUpperCase().slice(0, 4) : 'SOUBOR',
    color: k ? k[1] : '#9A9AA6',
    // Náhled jen u bezpečných rastrových formátů (SVG ne).
    image: /^image\/(png|jpe?g|gif|webp)$/.test(mime),
  };
}

export function fmtSize(b: number): string {
  if (!b) return '';
  return b < 1048576 ? `${Math.max(1, Math.round(b / 1024))} kB` : `${(b / 1048576).toFixed(1).replace('.', ',')} MB`;
}

/** Jméno pro snímek vložený ze schránky (prohlížeč ho pojmenuje image.png). */
export function pastedName(f: File): string {
  if (f.name && f.name !== 'image.png') return f.name;
  const ext = (f.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
  const d = new Date();
  return `Snímek ${d.getHours()}-${String(d.getMinutes()).padStart(2, '0')}.${ext}`;
}
